export default __webpack_public_path__ + "static/media/logo-mi-sueno-hogar.51201d27.png";